<template>
    <div v-if="searchResults.length > 0">
        <table class="table table-sm">
            <colgroup>
                <col width="200">
                <col width="25%">
                <col width="15%">
                <col width="auto">
            </colgroup>
            <thead>
                <tr>
                    <th>{{ translate('label.charters.illustration') }}</th>
                    <th>{{ translate('label.charters.period') }}</th>
                    <th>{{ translate('label.charters.type') }}</th>
                    <th>{{ translate('label.charters.place_of_writing') }}</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="searchResult in paginatedSearchResults">
                    <tr :key="'main-row-' + searchResult['_source']['id']" :class="searchResult['highlight'] ? 'has-snippet' : ''">
                        <td :rowspan="searchResult['highlight'] ? 2 : 1" v-if="searchResult['_source']['image_name_recto']">
                            <figure>
                                <a :href="'/charters/view/' + searchResult['_source']['id']" class="charter-thumb align-items-center justify-content-center">
                                    <image-view :image-server-base-path="imageServerPath + '/' + searchResult['_source']['id']"
                                                :filename="searchResult['_source']['image_name_recto']"
                                                :width="200">
                                    </image-view>
                                </a>
                                <figcaption>{{ searchResult['_source']['shelfmark'] }}</figcaption>
                            </figure>
                        </td>
                        <td v-else>
                            <figure>
                                <div class="noimage">
                                    <img src="https://dummyimage.com/200/000/fff.jpg&text=No+image+available" alt="Placeholder" width="200">
                                </div>
                                <figcaption>{{ searchResult['_source']['shelfmark'] }}</figcaption>
                            </figure>
                        </td>
                        <td>{{ searchResult['_source']['date_of_origin_' + locale] }}</td>
                        <td>
                            <img :src="'/img/dot-' + searchResult['_source']['type'] + '.svg'" :alt="translate('label.charter.' + searchResult['_source']['type'])"> <img v-if="searchResult['_source']['currently_on_display'] == 1" src="/img/dot-on-display.svg" :alt="translate('label.charter.currently_on_display')">
                        </td>
                        <td>{{ searchResult['_source']['place_of_origin_' + locale] }}</td>
                    </tr>
                    <tr v-if="searchResult['highlight']" :key="'snippet-row-' + searchResult['_source']['id']">
                        <td colspan="4">
                            <a :href="'/charters/view/' + searchResult['_source']['id']" >
                                <div class="snippet" v-for="(highlight, index) in searchResult['highlight']" :key="index" v-html="highlight[0] + '...'">
                                </div>
                            </a>
                        </td>
                    </tr>
                </template>
               
            </tbody>
        </table>
        <infinite-loading spinner="spiral" @infinite="infiniteHandler" :key="numberOfDisplayedResults">
        <div slot="no-results"></div>
        </infinite-loading>
    </div>
    <div v-else>
        <div class="mt-3 sans">
            <slot name="no-results-found-label">No results were found.</slot>
        </div>
    </div>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';
    export default {
        components: {
            InfiniteLoading
        },

        props: {
            searchQuery: { type: String, required: true },
            searchResults: { type: Array, required: true },
            imageServerPath: { type: String, required: true },
            locale: { type: String, required: false, default: 'de' }
        },

        data() {
            return {
                numberOfDisplayedResults: 50
            }
        },

        computed: {
            paginatedSearchResults() {
                return this.searchResults.slice(0, this.numberOfDisplayedResults);
            }
        },

        methods: {
            infiniteHandler(state) {
            if(this.numberOfDisplayedResults < this.searchResults.length) {
                this.numberOfDisplayedResults += 50;
            } else {
                state.complete();
            }
            }
        }
    }
</script>

<style lang="scss">
    .snippet {
        em {
            background-color: #efddac !important;
            display: inline-block;
            font-style: normal;
            padding:0 .125rem;
        } 
    }
    
</style>

<style lang="scss" scoped>
    th {
        white-space: nowrap;
    }
    .table tr.has-snippet td:not([rowspan="2"]) {
        border-bottom: 0;
    }
    .snippet {
        font-size: 1rem;
    }
    figure {
        margin: 0;
        img {
            padding: 0.125rem !important;
            max-width: 100%;
            max-height: 10rem !important;
            width: auto;
            height: auto;
        }
        figcaption {
            display: inline-block;
            font-size: 0.875rem;
        }
        a.charter-thumb {
            position: relative;
            float: left;
            margin: 0 0.5rem 0 0;
            width: 10rem;
            height: 10rem;
            background: #000;
            display: flex;
            &::before {
                content: url(/img/show-details.svg);
                position: absolute;
                top: 0.5rem;
                right: 0.5rem;
            }
        }
        .noimage {
            position: relative;
            float: left;
            margin: 0 0.5rem 0 0;
            width: 10rem;
            height: 10rem;
            background: #000;
            display: flex;
        } 
    }  
</style>
